var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 13.9267C9.33 13.9267 10.46 15.0677 10.46 16.4877V19.8967C10.46 21.3067 9.33 22.4567 7.92 22.4567H4.54C3.14 22.4567 2 21.3067 2 19.8967V16.4877C2 15.0677 3.14 13.9267 4.54 13.9267H7.92ZM19.4601 13.9267C20.8601 13.9267 22.0001 15.0677 22.0001 16.4877V19.8967C22.0001 21.3067 20.8601 22.4567 19.4601 22.4567H16.0801C14.6701 22.4567 13.5401 21.3067 13.5401 19.8967V16.4877C13.5401 15.0677 14.6701 13.9267 16.0801 13.9267H19.4601ZM7.92 2.45703C9.33 2.45703 10.46 3.60703 10.46 5.01803V8.42703C10.46 9.84703 9.33 10.987 7.92 10.987H4.54C3.14 10.987 2 9.84703 2 8.42703V5.01803C2 3.60703 3.14 2.45703 4.54 2.45703H7.92ZM19.4601 2.45703C20.8601 2.45703 22.0001 3.60703 22.0001 5.01803V8.42703C22.0001 9.84703 20.8601 10.987 19.4601 10.987H16.0801C14.6701 10.987 13.5401 9.84703 13.5401 8.42703V5.01803C13.5401 3.60703 14.6701 2.45703 16.0801 2.45703H19.4601Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.40e14a06f94ac412047f24caa47f8a56.svg";
export { ForwardRef as ReactComponent };